import React from 'react'

import SkeletonLoader from '@common/components/SkeletonLoader'

const SimulationSkeleton = () => {
  return <SkeletonLoader width="100%" height={42} />
}

export default SimulationSkeleton
